import React from 'react';
import { Form } from 'semantic-ui-react';
import { reduxForm } from 'redux-form';
import { Grid } from 'semantic-ui-react';

import { RangeDatePickerField } from 'Common/SemanticWrapper';
import { MEALS_PER_LABOR_HOUR_FORM_NAME } from 'Common/FormEnum';
import {
  MealsPerLaborHourFieldEnum as Fields,
  ReportFieldEnum as ReportFields,
} from 'Common/FieldEnum';
import { rangeDateValidator } from 'Common/FormHelper';
import { ReportFormatButtonGroup } from 'Components/forms/ReportFormatButtonGroup';

const MealsPerLaborHour = props => (
  <Form>
    <Grid>
      <Grid.Row>
        <Grid.Column width={8}>
          <RangeDatePickerField fromName={Fields.From} toName={Fields.To} />
        </Grid.Column>

        <Grid.Column width={8}>
          <Grid>
            <ReportFormatButtonGroup
              label="Report Format:"
              formName={MEALS_PER_LABOR_HOUR_FORM_NAME}
              fieldName={ReportFields.ReportFormat}
            />
          </Grid>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Form>
);

const validate = values =>
  rangeDateValidator(values[Fields.From], values[Fields.To]);

const MealsPerLaborHourForm = reduxForm({
  form: MEALS_PER_LABOR_HOUR_FORM_NAME,
  validate,
})(MealsPerLaborHour);

export { MealsPerLaborHourForm };



// WEBPACK FOOTER //
// ./src/pages/mealsperlaborhour/components/MealsPerLaborHourForm.js